import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginForm from "./pages/LoginForm";
import Dashboard from "./pages/Dashboard";
import VisitasContent from "./components/visitas/VisitasContent"
import ObrasContent from "./components/obras/ObrasContent";
import AdministracionContent from "./components/administracion/AdminContent";
import DashboardHome from "./components/DashboardHome";
import RequireAuth from "./RequireAuth";
import './styles/App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Ruta pública - Login */}
        <Route path="/" element={<LoginForm />} />
        
        {/* Rutas protegidas - Requieren autenticación */}
        <Route element={<RequireAuth />}>
          <Route path="/dashboard" element={<Dashboard />}>
            <Route index element={<DashboardHome />} />
            <Route path="visitas" element={<VisitasContent />} />
            <Route path="obras" element={<ObrasContent />} />
            <Route path="administracion" element={<AdministracionContent />} />
          </Route>
        </Route>

        {/* Ruta catch-all - Redirige a login si no existe */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
